import { Navigate, useParams } from "react-router";

export default function PortfolioCollectionPage() {
  const { id } = useParams();
  return <Navigate to={`/settings/portfolios/${id}/products`} replace />;
}
